/* import __COLOCATED_TEMPLATE__ from './two-factor-authentication-disabled-alert.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();